import { render, staticRenderFns } from "./contactPage.vue?vue&type=template&id=9872ed50&scoped=true&"
import script from "./contactPage.vue?vue&type=script&lang=js&"
export * from "./contactPage.vue?vue&type=script&lang=js&"
import style0 from "./contactPage.vue?vue&type=style&index=0&id=9872ed50&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9872ed50",
  null
  
)

export default component.exports